import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * useCompanyDispatchDefaults
 *
 * Live subscription to `/companies/{companyId}/settings/dispatch`. Returns the
 * company-wide Build Day fallback values so the sheet can prefill each tech
 * row through the fallback chain:
 *
 *   tech.defaultStartAddress  → company.companyDefaultDepot     → ''
 *   tech.defaultMaxStops      → company.companyDefaultMaxStops  → 6
 *
 * Missing doc / missing fields produce safe defaults so the consumer never
 * needs to null-guard.
 */
export function useCompanyDispatchDefaults(companyId) {
  const [defaults, setDefaults] = useState({
    companyDefaultDepot: '',
    companyDefaultMaxStops: 6,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId || !db) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const ref = doc(db, 'companies', companyId, 'settings', 'dispatch');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        setDefaults({
          companyDefaultDepot: (data.companyDefaultDepot || '').trim(),
          companyDefaultMaxStops: typeof data.companyDefaultMaxStops === 'number'
            ? data.companyDefaultMaxStops
            : 6,
        });
        setLoading(false);
      },
      (err) => {
        console.error('[useCompanyDispatchDefaults] snapshot error:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [companyId]);

  return { defaults, loading };
}

export default useCompanyDispatchDefaults;
